module.exports = __webpack_public_path__ + "img/92042.1bab4397.svg";